// src/App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Main from './components/main';
import FriendsBets from './components/FriendsBets';
import Settings from './components/Settings';
import SignIn from './components/SignIn';
import SignUp from './components/SignUp';
import Notifications from './components/Notifications';
import AddFunds from './components/AddFunds';
import AddFunds2 from './components/AddFunds2';
import Success from './components/Success';
import Error from './components/Error';
import Home from './Home';
import Home2 from './Home2';
import NotFound from './components/NotFound';
import BetDetails from './components/BetDetails';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import HowItWorks from './components/HowItWorks';
import Community from './components/Community';
import Scores from './components/Scores';

const COMMUNITY_ALLOWED_EMAIL = "paulter17@gmail.com";

function canAccessCommunity(currentUser, systemSettings) {
  if (!currentUser) return false;
  if (!systemSettings?.hideCommunity) return true;
  return (currentUser.email || "").toLowerCase() === COMMUNITY_ALLOWED_EMAIL;
}

function canAccessScores(currentUser, systemSettings) {
  if (!currentUser) return false;
  if (!systemSettings?.hideScores) return true;
  return (currentUser.email || "").toLowerCase() === COMMUNITY_ALLOWED_EMAIL;
}

function PrivateRoute({ element }) {
  const { currentUser } = useAuth();
  return currentUser ? element : <Navigate to="/home" />;
}

function CommunityRoute({ element }) {
  const { currentUser, systemSettings } = useAuth();
  if (!currentUser) return <Navigate to="/home" />;
  return canAccessCommunity(currentUser, systemSettings) ? element : <Navigate to="/" />;
}

function ScoresRoute({ element }) {
  const { currentUser, systemSettings } = useAuth();
  if (!currentUser) return <Navigate to="/home" />;
  return canAccessScores(currentUser, systemSettings) ? element : <Navigate to="/" />;
}

function App() {
  const [setShowNotifications] = useState(false);


  return (
    
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<PrivateRoute element={<Main />} />} />
          <Route path="/AddFunds" element={<PrivateRoute element={<AddFunds />} />} />
          <Route path="/BetDetails" element={<PrivateRoute element={<BetDetails />} />} />
          <Route path="/Success" element={<PrivateRoute element={<Success />} />} />
          <Route path="/Error" element={<PrivateRoute element={<Error />} />} />
          <Route path="/FriendsBets" element={<PrivateRoute element={<FriendsBets />} />} />
          <Route path="/Settings" element={<PrivateRoute element={<Settings />} />} />
          <Route path="/Notifications" element={<PrivateRoute element={<Notifications isOverlay={true} onClose={() => setShowNotifications(false)}  />} />} />
          <Route path="/AddFunds2" element={<PrivateRoute element={<AddFunds2 />} />} />

          
          {/*Public routes */}
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/Home" element={<Home />} />
          <Route path="/Home2" element={<Home2 />}/>
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          {/* Community (private) */}
          <Route path="/Community" element={<CommunityRoute element={<Community />} />} />
          {/* Scores (private) */}
          <Route path="/Scores" element={<ScoresRoute element={<Scores />} />} />
          {/* Add more routes as needed */}

          {/* Catch all invalid routes */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
